const fr = {
  // ==================== COMMON ====================
  common: {
    loading: 'Chargement...',
    error: 'Erreur',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    start: 'Commencer',
    continue: 'Continuer',
    save: 'Enregistrer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    close: 'Fermer',
    delete: 'Supprimer',
    success: 'Succès',
    complete: 'Complet',
    incomplete: 'Incomplet',
    tests: 'tests',
    test: 'test',
    remaining: 'restant',
    completed: 'complété',
    minutes: 'min',
    questions: 'questions',
    backToHome: 'Retour à l\'accueil',
    backToSite: 'Retour au site',
  },

  // ==================== HEADER / NAV ====================
  header: {
    tests: 'Tests',
    pricing: 'Tarifs',
    testimonials: 'Témoignages',
    faq: 'FAQ',
    login: 'Connexion',
    start: 'Commencer',
  },

  // ==================== SALES LANDING ====================
  landing: {
    badge: '+2000 profils analysés',
    discoveryBadge: 'Offre Découverte',
    discoveryBadgeFrom: 'Dès',
    stickySecure: 'Sécurisé  ⚡ Immédiat',
    stickyPriceFrom: 'Dès',

    heroTitle1: 'Et si vous étiez bien plus capable',
    heroTitle2: 'que ce que les autres perçoivent ?',
    heroSubtitle: 'Beyond Personal Matrix croise jusqu\'à 6 tests psychométriques validés + une analyse IA pour révéler vos vrais super-pouvoirs et vous donner un plan d\'action concret.',
    heroCta: 'Découvrir mon profil',
    heroSecondary: 'Voir les offres',
    heroDeliverable: 'Accédez immédiatement à votre espace personnel, DISC, Big Five, Ennéagramme, VIA Forces, Valeurs Schwartz, MBTI, analysés et croisés par IA.',

    trustSecure: 'Paiement sécurisé',
    trustImmediate: 'Résultats immédiats',
    trustGuarantee: 'Garantie 14 jours',

    // Pillars
    pillar1Title: 'Connaissez-vous vraiment',
    pillar1Desc: 'Découvrez vos traits de personnalité, vos forces naturelles et vos motivations profondes, avec une précision scientifique.',
    pillar2Title: 'Boostez votre carrière',
    pillar2Desc: 'Que vous soyez salarié, freelance, étudiant ou manager : transformez votre profil en avantage concurrentiel.',
    pillar3Title: 'Mieux collaborer',
    pillar3Desc: 'Comprenez les autres aussi bien que vous-même pour créer des relations professionnelles plus fluides et efficaces.',

    // How it works
    howTitle: 'Comment ça',
    howTitleHighlight: 'marche ?',
    howSubtitle: 'De zéro à votre profil complet en moins d\'une heure',
    step: 'ÉTAPE',
    step1Title: 'Choisissez vos tests',
    step1Sub: 'Découverte: 2 tests | Complète: 5 tests',
    step2Title: 'Notre IA analyse vos résultats',
    step2Sub: 'Croisement de vos dimensions de personnalité',
    step3Title: 'Accédez à votre dashboard',
    step3Sub: 'Résultats interactifs • Accès immédiat',
    step4Title: 'Passez à l\'action',
    step4Sub: 'Plan personnalisé + recommandations concrètes',

    // Pain points
    painTitle: 'Vous vous reconnaissez dans',
    painTitleHighlight: 'ces situations ?',
    pain1: 'Vous ne savez pas vraiment quels sont vos points forts',
    pain2: 'Vous avez du mal à vous vendre en entretien ou en négociation',
    pain3: 'Vous sentez que vous n\'êtes pas dans le bon poste, mais vous ne savez pas pourquoi',
    pain4: 'Vous avez des difficultés à communiquer avec certaines personnes',
    pain5: 'Vous cherchez une direction claire pour votre carrière ou votre évolution',
    painConclusion: 'Beyond Personal Matrix vous donne les réponses que vous cherchez.',

    // Solutions
    solutionTitle: 'Avec Beyond Personal Matrix,',
    solutionTitleHighlight: 'vous obtenez',
    solution1: 'Une vision précise et objective de qui vous êtes vraiment',
    solution2: 'La connaissance de vos forces pour mieux vous positionner',
    solution3: 'La compréhension de vos motivations profondes et de vos valeurs',
    solution4: 'Des clés concrètes pour mieux communiquer et collaborer',
    solution5: 'Un plan d\'action personnalisé pour votre prochaine étape professionnelle',
    solutionConclusion1: 'Résultats et analyse IA disponibles en ',
    solutionConclusion2: 'moins d\'une heure.',

    // Tests section
    testsTitle: '6 Tests Psychométriques',
    testsTitleHighlight: 'Validés Scientifiquement',
    testsSubtitle: 'Chaque test explore une dimension unique de votre personnalité',
    testsDiscName: 'DISC',
    testsDiscDesc: 'Comprenez votre style de communication et d\'interaction. Dominant, Influent, Stable ou Consciencieux ?',
    testsBigfiveName: 'Big Five',
    testsBigfiveDesc: 'Mesurez vos 5 grands traits de personnalité. La référence mondiale en psychologie de la personnalité.',
    testsEnneagramName: 'Ennéagramme',
    testsEnneagramDesc: 'Identifiez vos motivations profondes. 9 types, 9 façons de voir le monde.',
    testsViaName: 'VIA - Forces',
    testsViaDesc: 'Découvrez vos 24 forces et vos super-pouvoirs. Basé sur les recherches de Martin Seligman.',
    testsSchwartzName: 'Valeurs Schwartz',
    testsSchwartzDesc: 'Clarifiez vos 10 valeurs fondamentales. Ce qui guide vraiment vos choix de vie.',
    testsMbtiName: 'MBTI',
    testsMbtiDesc: 'Découvrez votre type parmi 16 profils. Comment vous percevez le monde et prenez vos décisions.',
    testsMbtiTag: 'Offres Complète & Duo',

    // AI section
    aiTag: 'Intelligence Artificielle',
    aiTitle: '+ Une Analyse IA',
    aiTitleHighlight: 'Exclusive',
    aiSubtitle: 'Notre IA croise les résultats de vos tests pour vous révéler des insights uniques sur vous-même',
    aiFeat1: 'Votre profil de personnalité complet, synthétisé en langage clair',
    aiFeat2: 'Vos super-pouvoirs professionnels identifiés',
    aiFeat3: 'Vos axes de développement et comment les travailler',
    aiFeat4: 'Des recommandations de carrière adaptées à votre profil',
    aiFeat5: 'Votre style de communication idéal pour gagner en impact',
    aiDashboard: 'Dashboard interactif accessible immédiatement après vos tests',
    aiDuoTitle: 'Offre Duo Exclusive',
    aiDuoSubtitle: 'Rapport de compatibilité IA',
    aiDuoDesc: 'Découvrez comment vos profils se complètent ! Notre IA analyse les résultats de 2 personnes pour révéler :',
    aiDuoFeat1: 'Points de complémentarité naturels',
    aiDuoFeat2: 'Zones de tension potentielles',
    aiDuoFeat3: 'Conseils de communication personnalisés',
    aiDuoFeat4: 'Forces combinées du duo',

    // Pricing
    pricingTitle: 'Choisissez Votre',
    pricingTitleHighlight: 'Formule',
    pricingSubtitle: 'Des offres adaptées à vos besoins et votre budget',
    pricingGuarantee: 'Garantie satisfait ou remboursé 14 jours',
    pricingQuestion: 'Une question avant d\'acheter ? Écrivez-nous, réponse en moins de 2h.',
    pricingReassurance: 'Accès immédiat · Dashboard interactif · Garanti 14 jours',
    pricingLoading: 'Chargement...',
    pricingPer: '/ personne',

    // Products
    discoveryName: 'Découverte',
    discoverySub: '2 tests au choix',
    discoveryFeat1: '2 tests au choix parmi 5',
    discoveryFeat2: 'Rapport IA simplifié',
    discoveryFeat3: 'Dashboard interactif',
    discoveryFeat4: 'Accès 30 jours',
    discoveryBtn: 'Commencer',
    discoveryNote: 'MBTI non inclus',

    completeName: 'Complète',
    completeSub: '6 tests complets',
    completeFeat1: '6 tests psychométriques',
    completeFeat2: 'Incluant le MBTI',
    completeFeat3: 'Rapport IA complet + synthèse',
    completeFeat4: 'Dashboard interactif',
    completeFeat5: 'Accès 1 an',
    completeFeat6: 'Plan de développement personnalisé',
    completeBtn: 'Choisir',
    completeBadge: 'Populaire',

    duoName: 'Duo',
    duoSub: '2 personnes',
    duoPerPersonSuffix: '/ personne',
    duoFeat1: '6 tests par personne',
    duoFeat2: 'Rapports IA individuels complets',
    duoFeat3: '⭐ Rapport de compatibilité IA',
    duoFeat4: 'Comparez vos profils',
    duoFeat5: 'Accès 1 an',
    duoFeat6: 'Économisez 33%',
    duoBtn: 'Choisir Duo',
    duoBadge: 'Meilleur prix',

    // Testimonials
    testimonialsTitle: 'Ce qu\'ils disent de leur expérience',
    testimonialsTitleHighlight: 'Beyond',
    before: 'Avant',
    after: 'Après',
    testimonial1Name: 'Sophie M.',
    testimonial1Age: '28 ans',
    testimonial1Role: 'Chargée de projet, en reconversion',
    testimonial1Before: 'je ne savais pas mettre des mots sur ce que je valais vraiment.',
    testimonial1After: 'j\'ai décroché le poste de mes rêves deux mois plus tard.',
    testimonial1Quote: 'Beyond Personal Matrix m\'a donné une clarté que 3 ans de thérapie n\'avaient pas réussi à me donner.',
    testimonial2Name: 'Thomas R.',
    testimonial2Age: '35 ans',
    testimonial2Role: 'Freelance, consultant indépendant',
    testimonial2Before: 'pitcher mes services était un cauchemar, je ne savais pas quoi mettre en avant.',
    testimonial2After: 'mes missions ont augmenté de 40% en 3 mois.',
    testimonial2Quote: 'Connaître mon profil DISC et Big Five a tout changé.',
    testimonial3Name: 'Camille D.',
    testimonial3Age: '24 ans',
    testimonial3Role: 'Étudiante en Master RH',
    testimonial3Before: 'j\'allais en entretien sans savoir vraiment quoi dire sur moi.',
    testimonial3After: 'les recruteurs me disaient que j\'étais la candidate la plus préparée qu\'ils avaient vue.',
    testimonial3Quote: 'J\'ai signé mon contrat en 3 semaines.',

    // FAQ
    faqTitle: 'Questions',
    faqTitleHighlight: 'Fréquentes',
    faq1Q: 'À qui s\'adresse Beyond Personal Matrix ?',
    faq1A: 'À tout le monde ! Que vous soyez salarié, freelance, étudiant, en reconversion ou manager, nous vous aidons à mieux vous connaître. L\'offre Duo est parfaite pour couples, amis ou collègues qui veulent découvrir leur compatibilité.',
    faq2Q: 'Quelle est la différence entre les 3 offres ?',
    faq2A_p1: 'Découverte (',
    faq2A_p2: ') : 2 tests au choix + rapport IA simplifié, accès 30 jours. Complète (',
    faq2A_p3: ') : 5 tests + rapport IA complet + synthèse + plan de développement, accès 1 an. Duo (',
    faq2A_p4: ') : Tout de Complète pour 2 personnes + rapport de compatibilité IA exclusif.',
    faq2A: 'Découverte : 2 tests au choix + rapport IA simplifié, accès 30 jours. Complète : 6 tests + rapport IA complet + synthèse + plan de développement, accès 1 an. Duo : Tout de Complète pour 2 personnes + rapport de compatibilité IA exclusif.',
    faq3Q: 'Quels tests sont disponibles ?',
    faq3A: 'Nous proposons 5 tests psychométriques validés scientifiquement : DISC (style de communication), Big Five (5 traits de personnalité), Ennéagramme (motivations profondes), VIA (forces de caractère) et Valeurs Schwartz (valeurs fondamentales).',
    faq4Q: 'Qu\'est-ce que le rapport de compatibilité Duo ?',
    faq4A: 'C\'est une analyse IA exclusive qui compare les profils de 2 personnes pour révéler leurs points de complémentarité, les zones de tension potentielles, et des conseils concrets pour mieux communiquer et collaborer.',
    faq5Q: 'Combien de temps durent les tests ?',
    faq5A: 'Comptez environ 10-15 minutes par test. Vous pouvez faire des pauses et reprendre à tout moment. L\'offre Complète prend environ 45-60 minutes au total.',
    faq6Q: 'Les résultats sont-ils fiables ?',
    faq6A: 'Oui. Nous utilisons des tests psychométriques reconnus mondialement (DISC, Big Five, Ennéagramme, VIA, Schwartz), validés scientifiquement et utilisés par des millions de professionnels.',
    faq7Q: 'Mes données sont-elles sécurisées ?',
    faq7A: 'Absolument. Vos données sont hébergées en Europe, chiffrées et conformes au RGPD. Vous seul avez accès à vos résultats.',
    faq8Q: 'Et si les résultats ne me ressemblent pas ?',
    faq8A: 'C\'est rarissime, mais notre garantie satisfait ou remboursé de 14 jours s\'applique sans condition. Un email suffit.',

    // Final CTA
    finalTitle: 'Votre profil complet',
    finalTitleHighlight: 'vous attend.',
    finalSubtitle: 'Rejoignez +2000 personnes qui ont arrêté de se sous-estimer.',
    finalDiscoveryBtn: 'Découverte',
    finalCompleteBtn: 'Complète',
    finalReassurance: 'Dashboard interactif · Accès immédiat · Garanti 14 jours',

    // Footer
    legalNotices: 'Mentions légales',
    terms: 'CGV',
    privacy: 'Confidentialité',
    copyright: '© 2026 Tous droits réservés',

    // Hero CTAs (Phase 3)
    heroCtaPrimary: 'Démarrer Découverte',
    heroCtaSecondary: 'Voir l\u2019offre Complète',
    trustGdpr: 'RGPD conforme',
    trustAi: 'Analyse IA incluse',
    badgeMethodology: 'Profils cumulés depuis le lancement',

    // Free preview lead magnet
    previewTitle: 'Recevez un aperçu gratuit de votre profil',
    previewSub: 'Laissez votre email, on vous prépare un aperçu personnalisé de ce que BPM révèle sur vous. Sans engagement.',
    previewBtn: 'Recevoir mon aperçu',
    previewEmailPlaceholder: 'vous@email.com',
    previewSuccess: 'Merci ! Nous vous contactons prochainement avec votre aperçu.',
    previewConsent: 'J\u2019accepte de recevoir mon aperçu et des conseils BPM. Désinscription possible à tout moment.',
    previewInvalid: 'Email invalide.',
    previewMustConsent: 'Merci de cocher la case pour continuer.',
    previewGenericError: 'Une erreur est survenue. Veuillez réessayer.',

    testimonialsNote: 'Témoignages réels recueillis. Initiales et stylisation pour l\u2019anonymat.',

    // AI disclaimer & trademark
    aiDisclaimer: 'L\u2019analyse IA est générée à partir de vos réponses pour un usage de développement personnel. Elle ne constitue pas un diagnostic médical, psychologique ou clinique, ni un avis professionnel pour le recrutement ou l\u2019évaluation de tiers.',
    trademarkNote: 'MBTI\u00AE est une marque déposée de The Myers-Briggs Company. VIA\u00AE est une marque déposée du VIA Institute on Character. DISC est un modèle théorique du domaine public. Les questionnaires utilisés par BPM sont des outils originaux inspirés de ces modèles et ne constituent pas les instruments officiels de leurs ayants droit.',
  },

  // ==================== LOGIN ====================
  login: {
    title: 'Connexion',
    email: 'Email',
    emailPlaceholder: 'votre@email.com',
    password: 'Mot de passe',
    passwordPlaceholder: '••••••••',
    submit: 'Se connecter',
    noAccount: 'Pas encore de compte ?',
    discoverOffers: 'Découvrez nos offres',
  },

  // ==================== REGISTER ====================
  register: {
    title: 'Créer mon compte',
    paymentConfirmed: 'Paiement confirmé !',
    paymentConfirmedSub: 'Créez votre compte pour accéder à vos tests.',
    firstName: 'Prénom',
    firstNamePlaceholder: 'Jean',
    lastName: 'Nom',
    lastNamePlaceholder: 'Dupont',
    email: 'Email',
    emailPlaceholder: 'votre@email.com',
    password: 'Mot de passe',
    passwordMin: 'min 8 caractères',
    confirmPassword: 'Confirmer le mot de passe',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    passwordTooShort: 'Le mot de passe doit contenir au moins 8 caractères',
    strength: 'Force',
    strengthWeak: 'Faible',
    strengthMedium: 'Moyen',
    strengthGood: 'Bon',
    strengthStrong: 'Fort',
    situation: 'Situation actuelle',
    situationPlaceholder: 'Sélectionnez votre situation',
    situationOtherLabel: 'Précisez votre situation',
    situationOtherPlaceholder: 'Décrivez votre situation...',
    sector: 'Secteur d\'activité',
    sectorPlaceholder: 'Sélectionnez votre secteur (optionnel)',
    acceptCgu: 'J\'accepte les',
    cguLink: 'Conditions Générales d\'Utilisation',
    andThe: 'et la',
    privacyLink: 'Politique de Confidentialité',
    submit: 'Créer mon compte',
    mustAcceptCgu: 'Vous devez accepter les CGU pour continuer',
    accountAlreadyActive: 'Compte déjà activé',
    linkExpired: 'Lien expiré',
    linkInvalid: 'Lien invalide',
    contactUs: 'Nous contacter',
    verifyingLink: 'Vérification du lien...',
    situations: {
      etudiant: 'Étudiant(e)',
      jeune_diplome: 'Jeune diplômé(e)',
      recherche_emploi: 'En recherche d\'emploi',
      salarie: 'Salarié(e)',
      manager: 'Manager / Responsable d\'équipe',
      dirigeant: 'Dirigeant(e) / Cadre supérieur(e)',
      freelance: 'Freelance / Indépendant(e)',
      entrepreneur: 'Entrepreneur(e) / Chef(fe) d\'entreprise',
      liberal: 'Profession libérale',
      enseignant: 'Enseignant(e) / Formateur(trice)',
      sante: 'Professionnel(le) de santé',
      artiste: 'Artiste / Créateur(trice)',
      reconversion: 'En reconversion professionnelle',
      parent_foyer: 'Parent au foyer',
      retraite: 'Retraité(e)',
      autre: 'Autre situation',
    },
    sectors: [
      'Tech / IT',
      'Finance / Banque',
      'Santé / Médical',
      'Commerce / Retail',
      'Marketing / Communication',
      'Ressources Humaines',
      'Industrie / Manufacturing',
      'Éducation / Formation',
      'Conseil / Consulting',
      'Autre'
    ],
  },

  // ==================== CHECKOUT ====================
  checkout: {
    orderTitle: 'Votre commande',
    brandName: 'Beyond Personal Matrix',
    forTwoPersons: 'pour 2 personnes',
    yourInfo: 'Vos informations',
    person1: 'Personne 1',
    person2: 'Personne 2',
    firstName: 'Prénom',
    lastName: 'Nom',
    email: 'Email',
    emailPlaceholder: 'vous@email.com',
    email2Placeholder: 'partenaire@email.com',
    chooseTests: 'Choisissez vos 2 tests',
    chooseTestsSub: 'Sélectionnez 2 tests parmi les 5 disponibles',
    testsSelected: 'tests sélectionnés',
    testNotAvailable: 'Test non disponible dans le pack Découverte',
    mbtiNote: 'Le test MBTI est disponible uniquement dans les offres Complète et Duo',
    duoNote: 'Les deux personnes recevront un email d\'activation',
    payBtn: 'Payer',
    processing: 'Traitement...',
    securePayment: 'Paiement sécurisé',
    acceptTerms: 'En cliquant sur "Payer", vous acceptez nos',
    termsLink: 'CGV',
    and: 'et notre',
    privacyLink: 'politique de confidentialité',
    guarantee: 'Garantie satisfait ou remboursé 14 jours',
    cbVisa: 'CB, Visa, Mastercard',
    errorFirstName: 'Veuillez entrer votre prénom et nom',
    errorEmail: 'Veuillez entrer un email valide',
    errorDuoName: 'Veuillez entrer le prénom et nom de la 2ème personne',
    errorDuoEmail: 'Veuillez entrer un email valide pour la 2ème personne',
    errorTests: 'Veuillez sélectionner 2 tests',
    errorGeneric: 'Une erreur est survenue. Veuillez réessayer.',
    returnBtn: 'Retour',

    // Pack features
    discoveryFeatures: ['2 tests au choix parmi 5', 'Rapport IA simplifié', 'Accès 30 jours'],
    completeFeatures: ['6 tests complets (incluant MBTI)', 'Rapport IA complet + synthèse', 'Plan de développement', 'Accès 1 an'],
    duoFeatures: ['6 tests par personne (x2)', 'Rapports IA individuels', 'Rapport de compatibilité IA', 'Accès 1 an'],

    // Legal consent checkboxes
    acceptTermsCheck: 'J\u2019accepte les',
    acceptTermsCheckEnd: 'et la',
    waiveWithdrawal: 'Je demande expressément que mon accès aux Services débute immédiatement après le paiement et je reconnais perdre mon droit de rétractation de 14 jours conformément à l\u2019article L.221-28 13\u00B0 du Code de la consommation.',
    mustAcceptAll: 'Vous devez cocher les deux cases pour continuer.',
  },

  // ==================== THANK YOU ====================
  thankYou: {
    verifying: 'Vérification du paiement...',
    errorTitle: 'Une erreur est survenue',
    errorDesc: 'Nous n\'avons pas pu vérifier votre paiement. Si vous avez été débité, contactez-nous.',
    contactUs: 'Nous contacter',
    pendingTitle: 'Paiement en cours de traitement',
    pendingDesc: 'Votre paiement est en cours de vérification. Vous recevrez un email dès qu\'il sera confirmé.',
    successTitle: 'Paiement confirmé !',
    checkEmail: 'Vérifiez votre boîte email',
    emailComing: 'Votre lien d\'activation arrive dans les prochaines minutes.',
    resend: 'Renvoyer l\'email',
    resending: 'Envoi en cours...',
    resendsLeft: 'renvoi(s) restant(s)',
    noEmailContact: 'Contactez-nous si vous ne recevez pas l\'email.',
    tipSpam: 'Pensez à vérifier vos spams ou promotions',
    tipFrom: 'L\'email provient de',
    needHelp: 'Besoin d\'aide ?',

    // Upsell (Phase 3)
    upsellTitlePrefix: 'Passez à l\u2019offre Complète pour',
    upsellTitleSuffix: 'de plus',
    upsellTitle: 'Passez à l\u2019offre Complète',
    upgradeTitle: 'Bienvenue dans votre pack {packName}\u00A0!',
    upgradeBody: 'Votre accès a été mis à jour. Vous pouvez maintenant accéder à toutes les fonctionnalités de votre nouveau pack.',
    upgradeCta: 'Aller au dashboard →',
    upsellSub: 'Débloquez 4 tests supplémentaires + MBTI + accès 1 an + plan de développement personnalisé.',
    upsellFeat1: '4 tests supplémentaires (Big Five, Ennéagramme, VIA, Schwartz)',
    upsellFeat2: 'Test MBTI inclus',
    upsellFeat3: 'Accès 1 an à votre dashboard',
    upsellFeat4: 'Plan de développement personnalisé',
    upsellBtn: 'Passer à Complète',
  },

  // ==================== USER DASHBOARD ====================
  dashboard: {
    hello: 'Bonjour',
    progress: 'Votre progression',
    testsCompleted: 'tests complétés',
    dimensions: 'Les 6 dimensions BPM',
    selectMultiple: 'Sélectionner plusieurs tests',
    loadingDashboard: 'Chargement de votre dashboard...',
    exportPdf: 'Exporter PDF',
    exporting: 'Export...',
    viewResults: 'Voir résultats',
    startTest: 'Commencer',
    resumeTest: 'Reprendre',

    // Locked tests / upsell
    testLocked: 'Verrouillé',
    upgradePrompt: 'Inclus dans le pack Complète',
    upgradeCTA: 'Passer à Complète',
    upgradeFromDiscovery: 'Passer à Complète pour {price} →',
    accessExpiresOn: 'Accès actif jusqu\u2019au',

    // Complete → Duo banner
    upgradeFromComplete: {
      title: 'Découvrez votre compatibilité Duo',
      subtitle: 'Invitez votre partenaire à passer les 6 tests et obtenez un rapport de compatibilité IA personnalisé.',
      feature1: 'Les 6 tests pour votre partenaire',
      feature2: 'Rapport de compatibilité IA approfondi',
      feature3: 'Conseils de communication adaptés',
      partnerEmailPlaceholder: 'Email de votre partenaire',
      cta: 'Passer à Duo pour {price} →',
      disclaimer: 'Vous avez déjà payé Complète. L\u2019upgrade Duo est proposé à {price} au lieu de {fullPrice}.',
    },

    // AI Synthesis
    synthesisLocked: 'Synthèse IA verrouillée',
    synthesisLockedDesc: 'Complétez les 6 tests pour débloquer votre analyse personnalisée',
    synthesisTitle: 'Synthèse IA Personnalisée',
    synthesisAvailable: 'Disponible !',
    synthesisReadyDesc: 'Votre analyse complète est prête à être générée. Notre IA va croiser vos 6 tests pour créer un profil unique et des recommandations personnalisées.',
    generateSynthesis: 'Générer ma synthèse IA',
    generating: 'Génération en cours...',
    regenerate: 'Régénérer la synthèse',
    regenerating: 'Régénération...',
    synthesisError: 'Erreur lors de la génération de la synthèse. Réessayez plus tard.',
    synthesisComplete6: 'Complétez les 6 tests pour débloquer la synthèse IA',
    yourProfile: 'Ton profil',
    strongPoints: 'Points forts',
    watchPoints: 'Points de vigilance',
    yourDrivers: 'Tes moteurs',
    keyValues: 'Valeurs clés',
    objective: 'Objectif',
    complementaryProfiles: 'Profils complémentaires',

    // Group section
    myTeam: 'Mon équipe',
    members: 'membres',
    slotAvailable: 'Slot disponible',
    sendInvite: 'Envoyer une invitation',
    inviteSent: 'Invitation envoyée, En attente',
    resend: 'Relancer',
    reassign: 'Réassigner',
    privateResults: 'Résultats privés',
    viewProfile: 'Voir profil',
    you: '(vous)',
    inviteMember: 'Inviter un membre',
    emailAddress: 'Adresse email',
    sendInviteBtn: 'Envoyer l\'invitation',
    sending: 'Envoi...',
    inviteSentTo: 'Invitation envoyée à',
    shareTitle: 'Partage de vos résultats',
    shareQuestion: 'Autoriser',
    shareQuestionEnd: 'à consulter votre profil complet ?',
    shareNo: 'Non, garder privé',
    shareYes: 'Oui, j\'autorise',
    shareChangeAnytime: 'Vous pouvez changer d\'avis à tout moment.',
  },

  // ==================== TEST SELECTION ====================
  testSelection: {
    title: 'Choisissez vos tests',
    subtitle: 'Sélectionnez les tests que vous souhaitez passer',
    completed: 'Complété',
    notCompleted: 'Non complété',
    startSelected: 'Commencer les tests sélectionnés',
    selectAtLeast: 'Sélectionnez au moins 1 test',
    testsSelected: 'tests sélectionnés',
    insight: 'Pourquoi ?',
    backToDashboard: 'Retour au tableau de bord',
  },

  // ==================== ASSESSMENT ====================
  assessment: {
    question: 'Question',
    of: 'sur',
    completed: 'complété',
    notAuthorizedToast: 'Ce test n\u2019est pas inclus dans votre pack. Découvrez le pack Complète.',
    mostLikeMe: 'Le plus comme moi',
    leastLikeMe: 'Le moins comme moi',
    chooseOne: 'Choisissez la réponse qui vous correspond le mieux :',
    notAtAll: 'Pas du tout',
    completely: 'Tout à fait',
    processing: 'Traitement...',
    viewResults: 'Voir Résultats',
    saveAnswers: 'Enregistrer',
    saving: 'Enregistrement...',
    sectionComplete: 'Section complète !',
    nextSection: 'Section suivante',
    testCompleteTitle: 'Test complété !',
    testCompleteDesc: 'Vos réponses ont été enregistrées avec succès.',
  },

  // ==================== RESULTS ====================
  results: {
    title: 'Votre Profil Comportemental',
    generatedOn: 'Généré le',
    profileIncomplete: 'Profil incomplet',
    testsCompleted: 'tests complétés',
    completeForFull: 'Complétez tous les tests pour obtenir votre profil complet et votre analyse approfondie.',
    continueTests: 'Continuer les tests',
    profileComplete: 'Profil comportemental complet',
    readyForMatching: 'Votre analyse est maintenant disponible.',
    synthesis: 'Synthèse de Votre Profil',
    dominantTraits: 'Traits Dominants',
    keyMotivations: 'Motivations Clés',
    networkRecommendations: 'Recommandations Personnalisées',
    networkRecommendationsSubtitle: 'Ces conseils vous aideront à optimiser vos échanges professionnels et personnels.',
    communicateWith: 'Pour communiquer avec moi',
    communicateWithSubtitle: 'Partagez ces informations avec vos collègues pour des échanges plus efficaces',
    avoid: 'À éviter avec moi',
    avoidSubtitle: 'Ce qui peut créer des frictions ou limiter nos échanges',
    networkContribution: 'Ma contribution unique',
    whatIBring: 'Ce que j\'apporte naturellement :',
    whatISeek: 'Ce que je recherche chez les autres :',
    backToDashboard: 'Retour au tableau de bord',
    completeRemaining: 'Compléter les tests restants',
  },
  // ==================== DUO REPORT ====================
  duo: {
    title: 'Rapport de Compatibilité Duo',
    subtitle: 'Analyse IA de votre duo',
    partner: 'Partenaire',
    waitingPartner: 'En attente de votre partenaire',
    waitingPartnerDesc: 'Votre partenaire doit créer son compte et compléter ses tests.',
    partnerProgress: 'Progression du partenaire',
    testsNeeded: 'Les deux personnes doivent compléter au moins 3 tests',
    generateReport: 'Générer le rapport de compatibilité',
    generating: 'Génération en cours...',
    regenerate: 'Régénérer le rapport',
    viewReport: 'Voir le rapport Duo',
    reportReady: 'Rapport prêt !',
    reportReadyDesc: 'Votre rapport de compatibilité IA est disponible.',
    yourDuo: 'Votre Duo',
    compatibilityScore: 'Score de compatibilité',
    complementarity: 'Points de complémentarité',
    tensions: 'Zones de tension potentielles',
    communicationTips: 'Conseils de communication',
    combinedStrengths: 'Forces combinées',
    actionPlan: 'Plan d\'action',
    globalAnalysis: 'Analyse globale',
    backToDashboard: 'Retour au dashboard',
    duoOffer: 'Offre Duo',
    duoOfferDesc: 'Rapport de compatibilité IA entre vous et votre partenaire',
    notDuo: 'Vous n\'avez pas souscrit à l\'offre Duo',
    notDuoDesc: 'L\'offre Duo inclut un rapport de compatibilité IA unique entre 2 personnes.',
    upgradeToDuo: 'Découvrir l\'offre Duo',
  },

  // ==================== TESTS DATA (for Assessment page) ====================
  tests: {
    disc: {
      name: 'DISC',
      description: 'Style de communication et d\'interaction',
      assessmentDescription: 'Identifiez votre profil comportemental : Dominance, Influence, Stabilité ou Conformité.',
    },
    bigfive: {
      name: 'Big Five',
      description: 'Les 5 grands traits de personnalité',
      assessmentDescription: 'Le modèle scientifique de référence mondiale pour mesurer votre personnalité.',
    },
    via: {
      name: 'VIA - Forces',
      description: 'Vos forces de caractère',
      assessmentDescription: 'Découvrez vos 24 forces de caractère et identifiez vos super-pouvoirs.',
    },
    schwartz: {
      name: 'Valeurs Schwartz',
      description: 'Vos valeurs fondamentales',
      assessmentDescription: 'Clarifiez les 10 valeurs qui guident véritablement vos choix de vie.',
    },
    enneagram: {
      name: 'Ennéagramme',
      description: 'Vos motivations profondes',
      assessmentDescription: '9 types, 9 façons de voir le monde. Identifiez votre type dominant.',
    },
    mbti: {
      name: 'MBTI',
      description: 'Votre type parmi 16 profils',
      assessmentDescription: 'Comment vous percevez le monde et prenez vos décisions.',
    },
  },

  // ==================== TEST SELECTION PAGE ====================
  testSelectionPage: {
    heroTitle: 'Votre Profil Comportemental BPM',
    heroDesc: 'Ces 6 évaluations scientifiques créent votre empreinte comportementale unique. Plus vous complétez de tests, plus votre analyse sera précise et pertinente.',
    card1Title: 'Connaissance de soi',
    card1Desc: 'Découvrez vos forces, motivations et axes de développement',
    card2Title: 'Recommandations ciblées',
    card2Desc: 'Recevez des conseils adaptés à votre profil unique',
    card3Title: 'Plan d\'action',
    card3Desc: 'Construisez votre stratégie de développement personnel',
    yourProgress: 'Votre progression',
    tests: 'tests',
    the6Dimensions: 'Les 6 dimensions BPM',
    selectAll: 'Tout sélectionner',
    completed: 'Complété',
    selectATest: 'Sélectionnez un test',
    startTests: 'Commencer',
    min: 'min',

    disc: {
      subtitle: 'Votre style de communication',
      description: 'Découvrez votre profil comportemental DISC (Dominance, Influence, Stabilité, Conformité) pour comprendre comment vous interagissez avec les autres.',
      insight: 'Essentiel pour identifier votre style relationnel et vos modes de communication préférés.',
    },
    bigfive: {
      subtitle: 'Les 5 dimensions de votre personnalité',
      description: 'Le modèle scientifique de référence mondiale. Mesurez votre Ouverture, Conscienciosité, Extraversion, Agréabilité et Stabilité émotionnelle.',
      insight: 'Révèle vos traits profonds pour une meilleure connaissance de soi.',
    },
    via: {
      subtitle: 'Vos forces de caractère',
      description: 'Identifiez vos 24 forces principales. Basé sur les travaux de Martin Seligman et la psychologie positive.',
      insight: 'Identifie vos super-pouvoirs naturels pour mieux les exploiter.',
    },
    schwartz: {
      subtitle: 'Vos valeurs fondamentales',
      description: 'Clarifiez vos 10 valeurs de base selon le modèle de Shalom H. Schwartz. Comprenez ce qui guide véritablement vos choix.',
      insight: 'Clarifie vos priorités pour des décisions plus alignées avec vos convictions.',
    },
    enneagram: {
      subtitle: 'Vos motivations profondes',
      description: 'Identifiez votre type de personnalité parmi 9 profils (Le Réformateur, L\'Altruiste, Le Battant...). Comprenez vos motivations fondamentales.',
      insight: 'Identifie vos leviers de motivation et points de vigilance.',
    },
    mbti: {
      subtitle: 'Votre type parmi 16 profils',
      description: 'Identifiez votre type de personnalité parmi 16 combinaisons (INTJ, ENFP, ESTJ...). Comprenez comment vous percevez le monde, traitez l\'information et prenez vos décisions.',
      insight: 'Optimise la collaboration : identifie les binômes et équipes complémentaires pour des projets réussis.',
    },
    why: 'Pourquoi ?',
  },

  // ==================== LEGAL PAGES ====================
  legal: {
    backToHome: 'Retour à l\u2019accueil',
    contactLabel: 'Contact',
    contactEmail: 'contact@beyondpersonalmatrix.com',
    notices: {
      title: 'Mentions légales',
      body: 'Contenu finalisé par notre conseil juridique. Pour toute question, contactez-nous.',
    },
    terms: {
      title: 'Conditions Générales de Vente',
      body: 'Contenu finalisé par notre conseil juridique. Les présentes CGV régissent l\u2019utilisation des services Beyond Personal Matrix. Pour toute question, contactez-nous.',
    },
    privacy: {
      title: 'Politique de Confidentialité',
      body: 'Contenu finalisé par notre conseil juridique. Vos données sont hébergées en Europe, chiffrées et conformes au RGPD. Pour toute question, contactez-nous.',
    },
  },

  // ==================== COOKIE BANNER ====================
  cookie: {
    title: 'Vos préférences de confidentialité',
    body: 'Nous utilisons des cookies pour analyser l\u2019audience du site et améliorer votre expérience. Vous pouvez accepter, refuser ou personnaliser votre choix à tout moment.',
    acceptAll: 'Tout accepter',
    refuse: 'Refuser',
    customize: 'Personnaliser',
    customizeTitle: 'Personnaliser mes cookies',
    necessary: 'Strictement nécessaires',
    necessaryDesc: 'Cookies indispensables au fonctionnement du site (authentification, panier). Toujours actifs.',
    analytics: 'Mesure d\u2019audience',
    analyticsDesc: 'Nous aident à comprendre l\u2019utilisation du site (PostHog, hébergé en UE).',
    save: 'Enregistrer mes choix',
  },

  // ==================== 404 ====================
  notFound: {
    title: 'Page introuvable',
    body: 'La page que vous cherchez n\u2019existe pas ou a été déplacée.',
    cta: 'Retour à l\u2019accueil',
  },

  // ==================== UPGRADE (inter-pack) ====================
  upgrade: {
    invalidPartnerEmail: 'Veuillez renseigner un email valide pour votre partenaire',
    partnerSameAsUser: 'L\u2019email du partenaire doit être différent du vôtre',
    errorGeneric: 'Une erreur est survenue. Veuillez réessayer.',
    processing: 'Redirection vers le paiement...',
  },
};

export default fr;
